import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: ()=> import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'supportcenter',
    loadChildren: () => import('./supportcenter/supportcenter.module').then(m => m.SupportcenterModule)
  },
  {
    path: 'account',
    loadChildren: ()=> import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'official',
    loadChildren: ()=> import('./official/official.module').then(m => m.OfficialModule)
  },
  {
    path: 'mail',
    loadChildren: ()=> import('./mail/mail.module').then(m => m.MailModule)
  },{
    path: 'contact',
    loadChildren: ()=> import('./contact/contact.module').then(m => m.ContactModule)
  },
  {
    path: 'install',
    loadChildren: ()=> import('./install/install.module').then(m => m.InstallModule)
  },
  {
    path: 'user',
    loadChildren: ()=> import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'openjob',
    loadChildren: () => import('./openjob/openjob.module').then(m => m.OpenjobModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule)
  },{
    path: 'market',
    loadChildren: () => import('./market/market.module').then(m => m.MarketModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
